import {
  Factory,
  Building2,
  FlaskConical,
  Ship,
  ShieldCheck,
  Landmark,
  Boxes,
  Atom,
} from 'lucide-react';
import { Typography } from './Typography';
import styles from './IndustryVisual.module.css';
const data = [
  { name: 'Промышленность', Icon: Factory },
  { name: 'Нефтегаз', Icon: Building2 },
  { name: 'Химпром', Icon: FlaskConical },
  { name: 'Судостроение', Icon: Ship },
  { name: 'Сертификация', Icon: ShieldCheck },
  { name: 'Госсектор', Icon: Landmark },
  { name: 'Металлургия', Icon: Boxes },
  { name: 'Урановая отрасль', Icon: Atom },
];
export function IndustryVisual() {
  return (
    <div className={styles.canvas} aria-label="Отрасли клиентов">
      <div className={styles.tags}>
        {data.map(({ name, Icon }, i) => (
          <div key={name} className={`${styles.tag} ${styles[`tag${i}`]}`}>
            <Icon size={24} strokeWidth={1.5} aria-hidden />
            <Typography as="span" variant="tag" tone="inherit">
              {name}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
}
